export type TutorialStepPosition = 'top' | 'bottom' | 'left' | 'right';

export interface TutorialStep {
    selector: string;
    title: string;
    description: string;
    position?: TutorialStepPosition;
}

export interface TutorialState {
    isActive: boolean;
    currentStep: number;
    steps: TutorialStep[];
}

type TutorialListener = (state: TutorialState) => void;

const initialState: TutorialState = {
    isActive: false,
    currentStep: 0,
    steps: [],
};

let state: TutorialState = { ...initialState };
const listeners = new Set<TutorialListener>();

function emit(): void {
    const snapshot = { ...state, steps: [...state.steps] };
    listeners.forEach((listener) => listener(snapshot));
}

export function subscribeTutorial(listener: TutorialListener): () => void {
    listener({ ...state, steps: [...state.steps] });
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function getTutorialState(): TutorialState {
    return { ...state, steps: [...state.steps] };
}

export function startTutorial(steps: TutorialStep[]): void {
    state = {
        isActive: true,
        currentStep: 0,
        steps: [...steps],
    };
    emit();
}

export function nextTutorialStep(): void {
    if (state.currentStep < state.steps.length - 1) {
        state = { ...state, currentStep: state.currentStep + 1 };
        emit();
        return;
    }
    endTutorial();
}

export function previousTutorialStep(): void {
    if (state.currentStep > 0) {
        state = { ...state, currentStep: state.currentStep - 1 };
        emit();
    }
}

export function skipTutorial(): void {
    endTutorial();
}

export function endTutorial(): void {
    state = { ...initialState, steps: [] };
    emit();
}

export function isTutorialActive(): boolean {
    return state.isActive;
}
